import React from 'react'

export const LayoutContext = React.createContext({})
export const LayoutProvider = LayoutContext.Provider
